import { Uniform, UniformsLib, UniformsUtils } from "three";
import { globalCameraWorld } from "../shader/GlobalUniforms";
import { Vector2, Vector3, Matrix4 } from "flavr-math";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const IMAGE_VERTEX_SHADER = glslify(require("./image.vert"));
const IMAGE_FRAGMENT_SHADER = glslify(require("./image.frag"));
export const IMAGE_SHADER = {
    uniforms: UniformsUtils.merge([
        UniformsLib.common,
        {
            cameraWorld: new Uniform(globalCameraWorld),
            imageScale: new Uniform(new Vector2(1, 1)),
            modelPosition: new Uniform(new Vector3()),
            modelRotation: new Uniform(new Vector3()),
            modelScale: new Uniform(new Vector3(1, 1, 1)),
            snap: new Uniform(new Vector2(Math.PI, Math.PI)),
            depthOffset: new Uniform(0),
            roomMatrix: new Uniform(new Matrix4())
        }
    ]),
    vertexShader: IMAGE_VERTEX_SHADER,
    fragmentShader: IMAGE_FRAGMENT_SHADER
};
